<template>
    <div class="inlineblock-meaningless-wrapper">
        <ElasticButton
            :asyncClick="initWorkspaceDialog"
            :title="$t('Add one to List')"
            :disabledTooltip="disabledTooltip"
            :alwaysNeedTooltip="alwaysNeedTooltip"
            :disabled="false"
            class="pendo-track__function-bar__save-to-workspace"
        >
            <PtIcon slot="icon" icon="SolidFolderMany" />
            <template #text>
                {{ $t('Save') }}
            </template>
        </ElasticButton>
        <SavePatentToWorkspace
            v-if="patentService && showSpaceDialog"
            appendToBody
            :service="patentService"
        />
    </div>
</template>

<script>
import { AlertMixin } from 'library-@/mixins';
import ElasticButton from './ElasticButton';
import { Toast, Icon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/FolderMany.svg';
import { getViewParams } from 'library-@/utils/get-params';
import _ from 'lodash';
import {
    SavePatentToWorkspace,
    PatentService,
    DEFAULT_CONFIG,
    trackSaveToWorkspace,
} from 'library-@/config/save-to-workspace-config';

export default {
    name: 'SaveToWorkspaceComplex',
    components: {
        PtIcon: Icon,
        ElasticButton,
        SavePatentToWorkspace,
    },
    mixins: [AlertMixin],
    props: {
        patentId: {
            type: String,
            required: true,
        },
        disabledTooltip: {
            type: Boolean,
            default: false,
        },
        alwaysNeedTooltip: {
            type: Boolean,
            default: false,
        },
        searchMode: {
            type: String,
        },
        groupMode: {
            type: String,
        },
        familyCount: {
            type: Number,
        },
    },
    data() {
        return {
            comp: undefined,
            showSpaceDialog: false,
            usedRange: [1, 2, 3],
            bioUk: [],
            // Chemical保存到workspace特殊参数
            chem_context_id: '',
            from_site: '',
            patentService: null,
        };
    },
    methods: {
        async initWorkspaceDialog() {
            const bioUk = _.get(getViewParams(), 'bio_uk');
            const { workspace_id: from_space_id, folder_id: from_folder_id, uk: from_uk, from_site } = getViewParams() || {};
            this.bioUk = bioUk ? bioUk.split(',') : [];
            this.chem_context_id = from_uk || '';
            this.from_site = from_site || '';
            const patentId = this.patentId;

            const vm = this;
            console.log(this.searchMode, this.groupMode, this.familyCount);
            class Service extends PatentService {
                constructor() {
                    super();
                    _.assign(this, DEFAULT_CONFIG);

                    this.vm = vm;
                    this.enableFamily = true;
                    /*
                    * 详情页写死1,只存在1的情况
                    * */
                    this.rangeSelector.allCounts = 1; // 单条专利
                    this.rangeSelector.groupCounts = 1; // 同族组专利

                    this.searchGroupMode = {
                        searchMode: vm.searchMode,
                        groupMode: vm.groupMode,
                        selectedGroupCounts: vm.familyCount,
                    };

                    this.init();
                }

                generateFamilyExpansionParams({ familyExpansion }) {
                    return {
                        type: 'PATENT',
                        family_expansion: familyExpansion,
                        patent_ids: [patentId],
                    };
                }

                generateSubmitSaveToWorkspaceParams(status) {
                    const { folderId, workspaceId, familyExpansion, counts, search_mode } = status;
                    const params = {
                        space_id: workspaceId,
                        folder_id: folderId,
                        family_expansion: familyExpansion,
                        patent_ids: [patentId],
                        type: 'PATENT',
                        patent_count: counts,
                        search_mode: search_mode,
                    };

                    if (vm.bioUk && vm.bioUk.length) {
                        params.bio_uk = vm.bioUk;
                        params.from_space_id = from_space_id;
                        params.from_folder_id = from_folder_id;
                    }

                    if (vm.chem_context_id && vm.from_site === 'chemical') {
                        params.chem_context_id = vm.chem_context_id;
                    }

                    this.$params = params;
                    return params;
                }

                onToastError({ message }) {
                    Toast({
                        message,
                        type: 'error',
                        showClose: true,
                    });
                }

                onClose(success) {
                    vm.showSpaceDialog = false;

                    if (success) {
                        const { template } = success;

                        Toast.closeAll();
                        Toast({
                            type: 'success',
                            message: template,
                            dangerouslyUseHTMLString: true,
                            duration: 5000,
                            showClose: true,
                        });

                        const {
                            // eslint-disable-next-line camelcase
                            space_id, folder_id, patent_count,
                        } = this.$params;

                        trackSaveToWorkspace({
                            space_id: space_id,
                            folder_id: folder_id,
                            num_patents: patent_count,
                        });
                    }
                }

            }

            this.patentService = new Service();

            this.showSpaceDialog = true;
        },
    },
};
</script>

<style lang="scss">
    .snap-save-to-workspace {
        display: inline;
    }
    .snap-save-to-workspace,
    .modal-container--save-to-workspace{
        .accordion-title {
            height: 45px;
            line-height: 25px;
            .title {
                height: 16px;
            }
            .snap-save-to-workspace-editable-text {
                height: 21px;
                line-height: 21px;
            }
        }
    }
</style>
